import Vue from 'vue';
import state from '../state';

export default {
  async loadClient() {
    const client = (await Vue.http.get('/api/client')).data;
    state.client.set(client);
  },
  async getClientLinkSets(){
    return (await Vue.http.get('/api/clients/linksets/getall')).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/client.service.js